import React from 'react';

export const QuestionNavigation = ({ 
  questions, 
  hasSelectedOption, 
  currentQuestionIndex, 
  markedQuestions, 
  handleQuestionButtonClick 
}) => (
  <div className="qnav-container">
    {questions.some(item => item.subject === "math") && (
      <>
        <h3 className="qnav-subject-title">Math:</h3>
        <div className="qnav-buttons-grid">
          {questions.map((item, index) => (
            item.subject === "math" ? (
              <button
                key={index}
                className={`qnav-button
                  ${hasSelectedOption[index] ? "qnav-answered" : ""}
                  ${currentQuestionIndex === index ? "qnav-current" : ""}
                  ${markedQuestions[index] ? "qnav-marked" : ""}`}
                onClick={() => handleQuestionButtonClick(index)}
              >
                {index + 1}
              </button>
            ) : null
          ))}
        </div>
      </>
    )}

    {questions.some(item => item.subject === "reasoning") && (
      <>
        <h3 className="qnav-subject-title">Reasoning:</h3>
        <div className="qnav-buttons-grid">
          {questions.map((item, index) => (
            item.subject === "reasoning" ? (
              <button
                key={index}
                className={`qnav-button
                  ${hasSelectedOption[index] ? "qnav-answered" : ""}
                  ${currentQuestionIndex === index ? "qnav-current" : ""}
                  ${markedQuestions[index] ? "qnav-marked" : ""}`}
                onClick={() => handleQuestionButtonClick(index)}
              >
                {index + 1}
              </button>
            ) : null
          ))}
        </div>
      </>
    )}

    {questions.some(item => item.subject === "english") && (
      <>
        <h3 className="qnav-subject-title">English:</h3>
        <div className="qnav-buttons-grid">
          {questions.map((item, index) => (
            item.subject === "english" ? (
              <button
                key={index}
                className={`qnav-button
                  ${hasSelectedOption[index] ? "qnav-answered" : ""}
                  ${currentQuestionIndex === index ? "qnav-current" : ""}
                  ${markedQuestions[index] ? "qnav-marked" : ""}`}
                onClick={() => handleQuestionButtonClick(index)}
              >
                {index + 1}
              </button>
            ) : null
          ))}
        </div>
      </>
    )}

    {questions.some(item => item.subject === "gk") && (
      <>
        <h3 className="qnav-subject-title">Gk:</h3>
        <div className="qnav-buttons-grid">
          {questions.map((item, index) => (
            item.subject === "gk" ? (
              <button
                key={index}
                className={`qnav-button
                  ${hasSelectedOption[index] ? "qnav-answered" : ""}
                  ${currentQuestionIndex === index ? "qnav-current" : ""}
                  ${markedQuestions[index] ? "qnav-marked" : ""}`}
                onClick={() => handleQuestionButtonClick(index)}
              >
                {index + 1}
              </button>
            ) : null
          ))}
        </div>
      </>
    )}

    <br></br><br></br>
  </div>
);